import React from 'react';
import { IframeWrapper } from './IframeWrapper';
import { MicroFrontendLoader } from './MicroFrontendLoader';
import { WebComponentLoader } from './WebComponentLoader';
import { EmbeddingErrorBoundary } from './EmbeddingErrorBoundary';
import type { EmbeddedService } from '../../../types/embedding';
import { useShellI18n } from '@/features/language/useI18n';

interface EmbeddingContainerProps {
  service: EmbeddedService;
  className?: string;
}

export const EmbeddingContainer: React.FC<EmbeddingContainerProps> = ({
  service,
  className,
}) => {
  const { t } = useShellI18n();

  const renderLoader = () => {
    switch (service.type) {
      case 'iframe':
        return <IframeWrapper service={service} className={className} />;
      case 'microfrontend':
        return <MicroFrontendLoader service={service} className={className} />;
      case 'webcomponent':
        return <WebComponentLoader service={service} className={className} />;
      default:
        return (
          <div className="embed-error">
            {t('Unknown embedding type: {{type}}', { type: service.type })}
          </div>
        );
    }
  };

  return (
    <div className="embed-container">
      <EmbeddingErrorBoundary>
        {renderLoader()}
      </EmbeddingErrorBoundary>
    </div>
  );
};
